import { router } from '@core/components/Router';
import { RoutePath } from '@core/types/route';
import {
  CORE_ROUTES,
  INSTRUCTOR_ROUTES,
  LEGAL_ROUTES,
  MARTIAL_ART_ROUTES,
  SELF_DEFENSE,
} from '@homepage/utils/app-routes';

import Training from './pages/training/Training';

const setAppRoutes = () =>
  router.addRoutes([
    ...CORE_ROUTES,
    ...LEGAL_ROUTES,
    ...INSTRUCTOR_ROUTES,
    ...MARTIAL_ART_ROUTES,
    ...SELF_DEFENSE,
    {
      element: <Training />,
      name: 'ma-training',
      path: RoutePath.KampfkunstTraining,
      text: 'Kampfkunst Training',
    },
  ]);

export default setAppRoutes;
